import { render, staticRenderFns } from "./AddProductMedicine.vue?vue&type=template&id=f9cc744a"
import script from "./AddProductMedicine.vue?vue&type=script&lang=js"
export * from "./AddProductMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports